<template>
    <div>
        <!-- <div>
            <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

        </div> -->
        <v-container fluid>
            <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
                <span v-if="snackbar_msg!=null">{{ snackbar_msg }}</span>
                <v-btn dark text @click="snackbar = false">Close</v-btn>
            </v-snackbar>
            <div class="d-flex justify-end">
      <v-btn 
       v-if="!is_admin"
        color="brand onBrand--text"
        dark
        small
        class="mb-2,mt-2"
        style="border-radius:8px"
        @click="videoDialog = true"
      >
      <v-icon left>mdi-youtube</v-icon>
      Watch Tutorial
      </v-btn>
      </div>
            <v-card class="box">
                <v-toolbar flat dense class="toolbar" >
                    <v-toolbar-title>Freez / Unfreez Salary Register</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-row justify="center" dense>
                    <v-col cols="12" sm="3" md="3" class="pt-3">
                        <v-autocomplete color="#0F2027" dense rounded required v-model="year" :items="year_list"
                            item-text="name" item-value="id" label="Salary Year" outlined @change="getSalaryMonth()" />
                    </v-col>
                    <v-col cols="12" sm="3" md="3" class="pt-3" v-if="year">
                        <v-autocomplete color="#0F2027" dense rounded required v-model="sal_month" return-object
                            :items="sal_month_list" item-text="sal_mon" item-value="id" label="Salary Month"
                            @change="checkMonthRegisterStatus()" outlined />
                    </v-col>
                    <v-col cols="12" sm="3" md="3" class="pt-3" v-if="sal_month">
        <v-autocomplete color="#0F2027" dense rounded v-model="section" :items="section_list"
            item-text="name" item-value="id" label="Section" outlined clearable />
    </v-col>
                    <v-col cols="12" sm="3" md="3" v-if="sal_month">
                        <!-- <v-btn class="button" v-if="sal_month" @click="freezunfreezSalaryRegister()" :loading="loader">Freez / Unfreez Salary Register</v-btn> -->
                        <v-switch color="#0F2027" v-model="sal_month.isfreezed" label="Freez / Unfreez Salary Register"
                            @change="freezunfreezSalaryRegister()"></v-switch>
                    </v-col>
                    <v-col cols="12" sm="3" md="3" v-if="sal_month">
                        <v-btn class="button" @click="fetchSalaryRegister()" :loading="loader">Fetch Complete Salary
                            Register</v-btn>
                    </v-col>
                </v-row>
            </v-card>
            <span v-if="freez_flag == 'No'">
                <center><strong>Note : {{fmsg}}</strong></center>
            </span>
            <!-- {{freez_flag}} {{fmsg}} -->
            <v-card class="box" v-if="emp_salary_reg_detail!=''">
                <v-toolbar flat dense class="toolbar">
                    <v-toolbar-title>Employee Salary Register Details</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-col cols="12" sm="12" md="12">
                    <v-simple-table fixed-header dense class="elevation-1" height="500px"
                        v-if="emp_salary_reg_detail.length > 0">
                        <thead>
                            <tr class="toolbar">
                                <td align="center">Sr. No.</td>
                                <td align="center">Employee</td>
                                <td align="center">No. Of Working Days</td>
                                <td align="center" v-for="(header,index) in comp_header" :key="index">{{header}}</td>
                                <td align="center">Gross Salary</td>
                                <td align="center">Gross Deduction</td>
                                <td align="center">Net Salary</td>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(s,index) in emp_salary_reg_detail" :key="index">
                                <td align="">{{index+1}}</td>
                                <td align="">{{s.emp_name}}</td>
                                <td>
                                    <center>{{s.emp_working_days}}</center>
                                </td>
                                <td v-for="comp in s.comp_value" :key="comp.emp_sd_id">
                                    <center>
                                        {{comp.s_value}}
                                    </center>
                                </td>
                                <td>
                                    <center>{{s.gross_salary}}</center>
                                </td>
                                <td>
                                    <center>{{s.gross_deductions}}</center>
                                </td>
                                <td>
                                    <center>{{s.net_salary}}</center>
                                </td>
                            </tr>
                        </tbody>
                    </v-simple-table>
                </v-col>
            </v-card>
        </v-container>
        <v-dialog v-model="videoDialog" max-width="1000px">
      <v-card>
        <v-card-title class="d-flex justify-space-between align-center grey lighten-4">
          <span>Freeze/Unfreeze Salary Register Tutorial</span>
          <v-btn icon @click="videoDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pa-0">
          <v-responsive :aspect-ratio="16/9">
           <iframe
              v-if="videoDialog"
              width="100%"
              height="100%"
              src="https://www.youtube.com/embed/cW9NTUn6QSs?si=0mqdYn4j5UokJYch"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            ></iframe>
          </v-responsive>
        </v-card-text>
      </v-card>
    </v-dialog>
    </div>
    <!-- /. root div -->
</template>
<script>
    import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {
    components: {
        Breadcrumbs,
    },
        data: () => ({
            loader: false,
            snackbar_msg: "",
            color: "",
            // extraBreadcrumbItems: [
              

            // ],
            // breadcrumbClass: "breadcrumb-style1",
            snackbar: false,
            videoDialog:false,
            title: "",
            description: "",
            sal_month_list: [],
            sal_month: null,
            comp_header:[],
            emp_salary_reg_detail:[],
            year:null,
            year_list:[],
            freez_flag:null,
            is_admin:false,
            fmsg:null,
            section: null,
    section_list: [],
        }),
        methods: {
            checkMonthRegisterStatus(){
                const data={
                  sal_month:this.sal_month.id,
                  section: this.section
                }
                 axios
                    .post("/Payroll/checkMonthRegisterStatus",data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                           this.freez_flag = res.data.freez_flag
                           this.fmsg = res.data.fmsg
                           this.section_list = res.data.section_list
                        }
                        else if (res.data.flag == "No") {
                            this.freez_flag = res.data.freez_flag
                           this.fmsg = res.data.snackbar
                           this.showSnackbar("#b71c1c", res.data.snackbar);
                        }  
                        else {
                            this.showSnackbar("#b71c1c", "Something went wrong!!!");
                            sessionStorage.setItem("error-trace", res.data.error_trace);
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                    })
                    .finally(() => {});
            },
            freezunfreezSalaryRegister(){
                 const data={
                  sal_month:this.sal_month.id,
                  isfreezed:this.sal_month.isfreezed,
              }
               axios
                    .post("/Payroll/savekMonthRegisterFreezUnfreez",data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                        //    this.freez_flag = res.data.freez_flag
                          //  this.fmsg = res.data.fmsg
                            this.showSnackbar("#4caf50", "Salary register freezed/unfreezed successfully..."); // show snackbar on success
                            this.getSalaryMonth();
                        } 
                         else if (res.data.flag == "No") {
                            this.fmsg = res.data.fmsg
                            this.freez_flag = res.data.freez_flag
                           this.showSnackbar("#b71c1c", res.data.snackbar);
                        }  
                        else {
                            this.showSnackbar("#b71c1c", "Something went wrong!!!");
                            sessionStorage.setItem("error-trace", res.data.error_trace);
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                    })
                    .finally(() => {});
            },
            fetchSalaryRegister() {
            this.emp_salary_reg_detail=[],this.comp_header=[]
              const data={
                  sal_month:this.sal_month.id,
                  section: this.section
              }
              this.loader = true
               axios
                .post("/Payroll/getSalaryRegisterFreezUnfreez",data)
                .then((res) => {
                    if (res.data.flag == "YES") {
                        this.emp_salary_reg_detail = res.data.emp_salary_reg_detail
                        this.comp_header = res.data.comp_header
                        this.section_list = res.data.section_list
                        this.loader = false
                       // this.sal_month=''
                    } else if(res.data.flag == "No"){
                        this.showSnackbar("#b71c1c", res.data.snackbar);
                        return
                        this.loader = false
                    }
                    else {
                         this.showSnackbar("#b71c1c", "Something went wrong!!!");
                         sessionStorage.setItem("error-trace", res.data.error_trace);
                         this.loader = false
                    }
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something Went Wrong");
                    this.loader = false
                })
                .finally(() => {
                    
                });
            },
            onLoad() {
                axios
                    .post("/Payroll/getYear")
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.year_list = res.data.year_list;
                            this.is_admin = res.data.is_admin;
                        } else {
                            this.showSnackbar("#b71c1c", "Something went wrong!!!");
                            sessionStorage.setItem("error-trace", res.data.error_trace);
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                    })
                    .finally(() => {});
            },
            getSalaryMonth() {
               // this.sal_month = null,
               // this.sal_month_list = []
                const data = {
                    year:this.year
                }
                axios
                    .post("/Payroll/getSalaryMonth",data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.sal_month_list = res.data.sal_month_list;
                        } else {
                            this.showSnackbar("#b71c1c", "Something went wrong!!!");
                            sessionStorage.setItem("error-trace", res.data.error_trace);
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                    })
                    .finally(() => {});
            },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
        },
        mounted() {
            this.onLoad();
        },
        watch: {},
    };
</script>
<style scoped>
/* .v-text-field{
      width: 80px;
} */
 thead{
        font-weight: bold !important;
    }
    th {
        font-weight: bold !important;
    }
    tr,
    td,
    th {
        border: 1px solid black;
        /* text-align: center; */
        font-size: small;
    }
    tr,
    tbody {
        border-bottom: 1px solid black;
        border: 1px solid black;
        font-size: small;
    }
    td {
        font-size: small;
    }
    @media (min-width: 320px) {
        td,
        th {
            display: table-cell !important;
            font-size: small;
        }
        td + td,
        th + th {
            width: auto;
            font-size: small;
        }
    }
    v-simple-table {
        white-space: nowrap !important;
        /* text-align: center; */
        font-size: small;
    }
    .mytable /deep/ thead th {
        background: #0f2027 !important; /* fallback for old browsers */
        background: -webkit-linear-gradient(to right, #2c5364, #203a43, #0f2027) !important; /* Chrome 10-25, Safari 5.1-6 */
        background: linear-gradient(to right, #2c5364, #203a43, #0f2027) !important; /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
        background-color: #0f2027 !important;
        color: white !important;
        font-weight: bold !important;
        white-space: nowrap !important;
        text-align: center;
    }
     .edit-avatar {
        transition: 0.3s;
        border: 1px solid #b0bec5;
    }
    .edit-avatar:hover {
        background-color: #b0bec5;
    }
    .edit-v-icon {
        padding-left: 6px;
        font-size: 15px;
    }
    .edit-v-icon:hover {
        color: white;
    }
</style>
